<template>
  <v-main>
    <v-container fluid grid-list-xl>
      <v-toolbar text color="white">
        <v-toolbar-title>Роли</v-toolbar-title>

        <v-divider
          class="mx-2"
          inset
          vertical />
        <v-spacer />
        <!--        <v-btn color="primary" @click="saveRoles">-->
        <!--          Сохранить-->
        <!--        </v-btn>-->
        <v-btn color="primary" @click="dialog=true">
          Добавить
        </v-btn>
        <!--<v-checkbox-->
        <!--ref="moreCustomers"-->
        <!--v-model="moreCustomers"-->
        <!--label="Добавить еще"-->
        <!--type="checkbox"-->
        <!--&gt;</v-checkbox>-->
      </v-toolbar>
      <v-row class="fill-height"
             align="start"
             justify="start">
        <v-col md="5">
          <v-data-iterator
            :items="items"
            no-data-text="Please select a product from the left hand menu to compare."
            hide-default-footer>
            <v-col slot="item" slot-scope="props">
              <v-card>
                <v-card-title>
                  <h4>{{ props.item.name }}</h4>
                  <v-icon @click="deleteRole(props.item)">
                    delete
                  </v-icon>
                </v-card-title>
                <v-divider />
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>Ввод отчетов:</v-list-item-content>
                    <v-list-item-content
                      class="align-end">
                      <v-checkbox v-model="props.item.reportAdd" @change="saveRoles()" />
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Вывод отчетов:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <v-checkbox v-model="props.item.reportRead" @change="saveRoles()" />
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Редактирование списка сотрудников:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <v-checkbox v-model="props.item.usersEdit" @change="saveRoles()" />
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Редактирование списка товаров:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <v-checkbox v-model="props.item.productsEdit" @change="saveRoles()" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-data-iterator>
        </v-col>
        <v-dialog ref="dialogWindow" v-model="dialog" max-width="500px">
          <!--<template v-slot:activator="{ on }"  >-->
          <!--<v-btn color="primary" dark class="mb-2" v-on="on" @click="createRow"-->
          <!--&gt;Новая запись</v-btn>-->
          <!--<v-btn color="primary" dark class="mb-2" v-on="on" @click="editMultiple" v-if="multipleEdit"-->
          <!--v-show="!showBtn">-->
          <!--Редактировать</v-btn>-->
          <!--</template>-->
          <v-card>
            <v-card-title>
              <span class="headline">Новая роль</span>
            </v-card-title>
            <v-row justify="center">
              <v-data-iterator
                :content-props="{ row: true, wrap: true }"
                :items="editItem"
                content-tag="v-layout"
                no-data-text="Please select a product from the left hand menu to compare."
                hide-default-footer>
                <v-col slot="item" slot-scope="props">
                  <v-card>
                    <v-card-title>
                      <v-text-field
                        v-model.trim="props.item.name"
                        label="Название"
                        hint="Введите название роли"
                        persistent-hint />
                    </v-card-title>
                    <v-divider />
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Ввод отчетов:</v-list-item-content>
                        <v-list-item-content
                          class="align-end">
                          <v-checkbox v-model="props.item.reportAdd" />
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Просмотр отчетов:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          <v-checkbox v-model="props.item.reportRead" />
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Редактирование списка сотрудников:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          <v-checkbox v-model="props.item.usersEdit" />
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Редактирование списка товаров:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          <v-checkbox v-model="props.item.productsEdit" />
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-btn color="primary"
                           dark
                           class="mb-2"
                           @click="createRole">
                      Добавить
                    </v-btn>
                  </v-card>
                </v-col>
              </v-data-iterator>
            </v-row>
          </v-card>
        </v-dialog>
      </v-row>
      <v-snackbar
        v-model="alert"
        :color="alertColor"
        :timeout="5000"
        top>
        {{ notificationText }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import {authHeader} from '../../_helpers'

export default {
  name: "RolesTable",
  data () {
    return {
      headers: [
        {text: 'id', value: 'id', align: 'left', class: ['d-none']},
        {text: 'Название', value: 'name', align: 'left'},
        {text: 'Возможности', value: 'rights', align: 'left'},
        {text: 'Действия', value: '', align: 'left'}
      ],
      editItem: [{
        name: '',
        reportAdd: false,
        reportRead: false,
        productsEdit: false,
        usersEdit: false,
        rights: ''
      }],
      alertColor: 'green',
      notificationText: 'Роли успешно изменены',
      alert: false,
      dialog: false,
      errorMessages: '',
      formHasErrors: false,
      itemsPerPageOptions: [4, 8, 12],
      itemsPerPage: 4,
      items: [],
      headersPost: {
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).token, 'Content-Type':
          'application/json'
      }
    }
  },
  methods: {
    saveRoles () {
      let vm = this
      axios({
        method: 'PUT',
        url: this.$store.state.tableData.backend + '/api/roles',
        headers: this.headersPost,
        data: this.items
      }).then((response) => {
        vm.alert = true
        vm.$store.dispatch("tableData/loadRoles")
      }).catch((error) => {
        vm.notificationText = 'Что-то пошло не так'
        vm.alertColor = 'red'
        vm.alert = true
        throw new Error(`You can't load the data`)
      })
    },
    createRole () {
      let vm = this
      axios({
        method: 'POST',
        url: this.$store.state.tableData.backend + '/api/roles',
        headers: this.headersPost,
        data: this.editItem[0]

      }).then((response) => {
        vm.notificationText = 'Роль успешно добавлена'
        vm.alertColor = 'green'
        vm.alert = true
        vm.dialog = false
        vm.items.push(response.data.response)
        vm.$store.dispatch("tableData/loadRoles")


      }).catch((error) => {
        vm.dialog = false
        vm.notificationText = 'Что-то пошло не так'
        vm.alertColor = 'red'
        vm.alert = true
        throw new Error(`You can't load the data`)
      })
    },
    deleteRole (item) {
      let vm = this
      axios({
        method: 'DELETE',
        url: this.$store.state.tableData.backend + '/api/roles/' + item.id,
        headers: this.headersPost

      }).then((response) => {
        vm.dialog = false
        vm.notificationText = 'Роль успешно удалена'
        vm.alertColor = 'green'
        vm.alert = true
        vm.items.pop(vm.items.indexOf(item))
        vm.$store.dispatch("tableData/loadRoles")

      }).catch((error) => {
        vm.dialog = false
        vm.notificationText = 'Что-то пошло не так'
        vm.alertColor = 'red'
        vm.alert = true
        throw new Error(`You can't load the data`)
      })
    }
  },

  asyncComputed: {
    data: {
      get () {
        const requestOptions = {
          method: 'GET',
          headers: authHeader()
        }
        this.loading = true
        let vm = this
        return axios(this.$store.state.tableData.backend + '/api/roles', requestOptions).then((response) => {
          vm.items = response.data
          vm.loading = false
          return response.data
          // this.$router.push(this.$route.query.redirect || '/')
        }).catch((error) => {
          throw new Error(`You can't load the data`)
        })
      },
      default: []
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/RolesTable.vue